/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Formvalidation_Fundaccesschoicerequired4Inputs */

const en_formvalidation_fundaccesschoicerequired4 = /** @type {(inputs: Formvalidation_Fundaccesschoicerequired4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You must grant access to at least one fund`)
};

/**
* | output |
* | --- |
* | "You must grant access to at least one fund" |
*
* @param {Formvalidation_Fundaccesschoicerequired4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const formvalidation_fundaccesschoicerequired4 = /** @type {((inputs?: Formvalidation_Fundaccesschoicerequired4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Formvalidation_Fundaccesschoicerequired4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_formvalidation_fundaccesschoicerequired4(inputs)
});
export { formvalidation_fundaccesschoicerequired4 as "formValidation_fundAccessChoiceRequired" }